/* eslint-disable @typescript-eslint/no-explicit-any */
// ✅ 正确：useState 永远在组件顶层调用

import { Input, message } from "antd";
import { Wallet } from "ethers";
import "./index.less";
import { CopyOutlined, LoadingOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { cdnUrl } from "@/utils/cdn";
import { isValidSuiPrivateKey } from "@/utils/check";
import { decodeSuiPrivateKey } from "@mysten/sui/cryptography";
import { Ed25519Keypair } from "@mysten/sui/keypairs/ed25519";
import { Secp256k1Keypair } from "@mysten/sui/keypairs/secp256k1";
import { Secp256r1Keypair } from "@mysten/sui/keypairs/secp256r1";
import { formatUnits } from "viem";
type Props = {
  privateKey: any;
  privateAddress: any;
  privateKeyBalance: any;
  setPrivateKey: (val: any) => void;
  setPrivateAddress: (val: any) => void;
};
export default function PrivateKeyOperate({
  privateKey,
  setPrivateKey,
  setPrivateAddress,
  privateAddress,
  privateKeyBalance,
}: Props) {
  const { t, i18n } = useTranslation();
  const copy = async (content: any) => {
    await navigator.clipboard.writeText(content);
    messageApi.open({
      type: "success",
      // content: "复制成功",
      content: t("tips.copy"),
    });
  };

  const [messageApi, contextHolder] = message.useMessage();
  const addressFromSuiPrivateKey = (value: string) => {
    const parsed = decodeSuiPrivateKey(value.trim());

    // 不同版本字段名可能是 schema 或 scheme
    const scheme = (parsed as any).schema ?? (parsed as any).scheme;
    const secretKey = (parsed as any).secretKey as Uint8Array;

    let keypair;
    switch (scheme) {
      case "ED25519":
        keypair = Ed25519Keypair.fromSecretKey(secretKey);
        break;
      case "Secp256k1":
        keypair = Secp256k1Keypair.fromSecretKey(secretKey);
        break;
      case "Secp256r1":
        keypair = Secp256r1Keypair.fromSecretKey(secretKey);
        break;
      default:
        throw new Error(`Unsupported scheme: ${scheme}`);
    }

    return keypair.getPublicKey().toSuiAddress();
  };

  const inputPrivayeKeyChange = (e: any) => {
    const value = e.target.value;
    setPrivateKey(value);

    try {
      const address = addressFromSuiPrivateKey(value);

      setPrivateKey(value);
      setPrivateAddress(address);
    } catch (error) {
      setPrivateAddress("");

      // 可选：避免用户还没输入完就一直弹错
      if (value.trim().length > 0) {
        messageApi.open({
          type: "error",
          content: t("customizedAuthorization.pleaseEnterCorrectPrivateKey"),
        });
      }
    }
  };

  // console.log("privateKeyBalance", privateKeyBalance)

  return (
    <div className="private-key-box">
      {contextHolder}
      <div className="private-col">
        {/* <div className="input-label">
          <div className="required">*</div>
          <div>{t("customizedAuthorization.pleaseEnterPrivateKey")}</div>
        </div> */}
        <div className="private-title">
          <div className="required">*</div>
          <div className="enter-privatekey">
            {t("customizedAuthorization.pleaseEnterPrivateKey")}
          </div>
        </div>
        <input
          value={
            (privateKey &&
              privateKey.length > 20 &&
              privateKey.slice(0, 6) + "***" + privateKey.slice(-4)) ||
            privateKey
          }
          onChange={inputPrivayeKeyChange}
          placeholder={t("customizedAuthorization.pleaseEnterPrivateKey")}
          className="private-input"
        />
      </div>

      <div className="private-col">
        <div className="text-center">
          {t("customizedAuthorization.walletAddress")}
        </div>
        <div className="readonly-box">
          {privateAddress?.length > 1 ? (
            <div className="address-text">
              <div>
                {privateAddress.slice(0, 4) + "..." + privateAddress.slice(-4)}
              </div>
              <img
                src={cdnUrl("/img/bsc/copy.svg")}
                alt=""
                onClick={() => copy(privateAddress)}
              />
            </div>
          ) : (
            "-"
          )}
        </div>
      </div>
      <div className="private-col">
        <div className="text-center">
          {t("customizedAuthorization.BnbBalance")}
        </div>
        <div className="readonly-box right">
          {formatUnits(BigInt(privateKeyBalance), 9) || "-"}
        </div>
      </div>
    </div>
  );
}
